<script setup lang="ts">
import type { AdminUserListItem } from "@simbelapp/order-sdk";
import AppButton from "~/components/Common/Buttons/AppButton.vue";
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import Tag from "~/components/Common/Tag.vue";
import { useUsers } from "~/composables/users/useUsers";
import ResetUserPasswordModal from "./ResetUserPasswordModal.vue";

const props = defineProps<{ user: AdminUserListItem }>();
const emit = defineEmits<{ hide: [] }>();

const { statusMapping } = useUsers();
const showResetPassword = ref(false);

function closeModal() {
  emit("hide");
}

function openResetPassword() {
  showResetPassword.value = true;
}

function passwordResetDone() {
  showResetPassword.value = false;
  closeModal();
}
</script>

<template>
  <CenterModal v-if="!showResetPassword" class="w-full max-w-[560px]" @hide="closeModal">
    <template #body>
      <div class="flex flex-col gap-6 p-6">
        <div class="flex flex-col gap-2">
          <h3 class="heading_3_demi text-primary-color">Détail utilisateur</h3>
          <div class="flex items-center gap-2">
            <p class="heading_4_demi text-primary-color">{{ props.user.fullname }}</p>
            <Tag v-if="props.user.status" :tag="statusMapping(props.user.status)" />
          </div>
        </div>

        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div class="flex flex-col gap-1">
            <p class="body_med text-secondary-color">Email</p>
            <p class="body_regular text-primary-color">{{ props.user.email ?? "-" }}</p>
          </div>
          <div class="flex flex-col gap-1">
            <p class="body_med text-secondary-color">Entreprise</p>
            <p class="body_regular text-primary-color">{{ props.user.companyName || "-" }}</p>
          </div>
          <div class="flex flex-col gap-1">
            <p class="body_med text-secondary-color">Matricule</p>
            <p class="body_regular text-primary-color">{{ props.user.employeeNumber ?? "-" }}</p>
          </div>
          <div class="flex flex-col gap-1">
            <p class="body_med text-secondary-color">Rôles</p>
            <p class="body_regular text-primary-color">{{ props.user.roles.join(", ") || "-" }}</p>
          </div>
        </div>

        <div class="flex flex-col gap-4 border-t border-stroke-color pt-4 sm:flex-row sm:justify-end">
          <AppButton label="Réinitialiser le mot de passe" @click="openResetPassword" />
        </div>
      </div>
    </template>
  </CenterModal>

  <ResetUserPasswordModal
    v-if="showResetPassword"
    :user="props.user"
    @hide="showResetPassword = false"
    @done="passwordResetDone"
  />
</template>
